module.exports = __webpack_public_path__ + "static/media/onboarding-users.es.019b5345.png";